const selfUploadModal = {
  success: {
    title: "Innsendingu lokið",
    subtitle: "Auðkenni hafa verið fjarlægð úr skránni þinni og hún er tilbúin til niðurhals",
    processedNote: "Auðkenni fjarlægð",
    rowsCount: "{{rowCount}} línur",
    readyNote: "Tilbúið til niðurhals eða deilingar",
    downloading: "Sæki...",
    downloadWorkbook: "Sækja vinnubók án auðkenna",
    downloadFile: "Sækja skrá án auðkenna",
    csvButtonTitle:
      "Fyrsta blað flatt út, hægt að velja hvaða dálka skal taka með",
    asCsv: "sem CSV",
    findFileInCatalog: "Þú finnur einnig þessa skrá í",
    dataCatalogLink: "yfirliti gagnasafna",
  },
  header: {
    title: "Senda inn mín gögn",
    subtitle:
      "Auðkenni verða fjarlægð úr skránni þinni og hún geymd á öruggan hátt. Þú velur hver hefur aðgang að henni.",
  },
};

export default selfUploadModal;
